/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable @typescript-eslint/no-unused-vars  */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useEffect, useRef, useState } from 'react';
import { FormikHelpers, FormikProps } from 'formik';
import Immutable from 'immutable';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import WebformStepCounter from '@uncinc/react-drupal-core/dist/Components/Webform/WebformStepCounter';
import { FormikWrapper, FormDatePicker as FormDatePickerComponent } from '@uncinc/uncinc-react-kitchen-sink';

// The library marks several DatePicker props as required that are effectively optional.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormDatePicker = FormDatePickerComponent as React.ComponentType<any>;
import { useExtendedFormikContext } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/FormikWrapper';
import isAlcoholUsageLimitReached from 'helpers/isAlcoholUsageLimitReached';
import { BuddiesFormValues } from '../../components/Forms/BuddiesForm/types';
import pick from '../../helpers/pick';
import { stripTime } from '../../helpers/formatDate';
import useClasses from '../../hooks/useClasses';
import usePopup from '../../hooks/usePopup';
import useToast from '../../hooks/useToast';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { userAddBuddy, userUpdate } from '../../store/actions/User';
import { webformSubmit } from '../../store/actions/Webform';
import useProgrammaticFocus from '../../hooks/useProgrammaticFocus';
import { UserState } from '../../types';
import { useModalContext } from '../../containers/Modal/Context';
import {
  BuddiesForm,
  Button,
  Popup,
  StepperField,
  SwitchButtons,
} from '../../components';
import {
  DOMAIN_ZELFHULP_ALCOHOL,
  DOMAIN_ZELFHULP_GOKKEN,
  DOMAIN_ZELFHULP_TABAK,
  ENABLE_REGISTRATIONS_START_DATE_STEP,
  URL_JELLINEK,
  URL_JELLINEK_GOAL_PROS_CONS,
  USAGE_STEP_INCREMENT,
  ZELFHULP_ALCOHOL_USAGE_WARNING_THRESHOLD,
  ZELFHULP_GOKKEN_MAX_USAGE,
  ZELFHULP_GOKKEN_USAGE_STEP_INCREMENT,
} from '../../config/constants';

import './style.scss';

enum Step {
  StopDate = 'StopDate',
  CurrentUsage = 'CurrentUsage',
  StopOrReduce = 'StopOrReduce',
  ImmediateOrGradual = 'ImmediateOrGradual',
  Buddy = 'Buddy',
  Done = 'Done',
}

interface ImmutableRootState<T> {
  getIn: (keyPath: any[], notSetValue?: T) => T;
}

function useCurrentDomain() {
  return useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], null));
}

function useValidationSchema(formType: 'stopOrReduce' | 'immediateOrGradual' | 'none' = 'none') {
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    monday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.monday').toLowerCase() })),
    tuesday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.tuesday').toLowerCase() })),
    wednesday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.wednesday').toLowerCase() })),
    thursday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.thursday').toLowerCase() })),
    friday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.friday').toLowerCase() })),
    saturday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.saturday').toLowerCase() })),
    sunday: Yup.string().required(t('pages.create_recovery_plan.current_usage.validation.required', { day: t('dates.sunday').toLowerCase() })),
    goal_monday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.monday').toLowerCase() })),
    goal_tuesday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.tuesday').toLowerCase() })),
    goal_wednesday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.wednesday').toLowerCase() })),
    goal_thursday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.thursday').toLowerCase() })),
    goal_friday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.friday').toLowerCase() })),
    goal_saturday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.saturday').toLowerCase() })),
    goal_sunday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.sunday').toLowerCase() })),
    ...(formType === 'stopOrReduce' ? {
      stopOrReduce: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.stopOrReduce.required')).oneOf(['stop', 'reduce']),
    } : {}),
    ...(formType === 'immediateOrGradual' ? {
      immediate_or_gradual: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.immediateOrGradual.required')).oneOf(['immediate', 'gradual']),
    } : {}),
  }).required();

  return validationSchema;
}

type FormValues = Yup.InferType<ReturnType<typeof useValidationSchema>>;

interface StopDateFormProps {
  nextStep: () => void;
}

const StopDateForm: React.FC<StopDateFormProps> = ({ nextStep }) => {
  type Form = Record<string, Date>;

  const dispatch = useTypedDispatch();
  const { t } = useTranslation();
  const toast = useToast();

  const [submitting, setSubmitting] = useState(false);

  const currentUserId = useSelector<ImmutableRootState<any>, any>((state) => state.getIn(['login', 'uid'], 0));
  const user = useSelector<ImmutableRootState<any>, any>((state) => state.getIn(['user', currentUserId]));
  const currentStartDate = user.getIn(['field_registrations_start_date', 0, 'value']);

  const schema = Yup.object().shape({
    startDate: Yup.date()
      .required()
      .max(
        new Date(currentStartDate),
        t('pages.account.settings.fields.registrations_start_date.validation.error'),
      ),
  });

  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { actionsRef } = useModalContext();


  const domain = useCurrentDomain();

  const onSubmit = async (values) => {
    const { startDate } = values;
    setSubmitting(true);

    await dispatch(userUpdate(currentUserId, {
      field_registrations_start_date: {
        value: stripTime(startDate),
      },
    })).then(() => {
      setSubmitting(false);
      nextStep();
    }).catch((err) => {
      toast.show(t('pages.account.settings.messages.error'), 'error');
      console.error(err);
    });
  };

  return (
    <>
      <h2 className={buildClass('title')}>
        {t('pages.create_recovery_plan.registrations_start_date.title')}
      </h2>

      <p className={buildClass('lead')}>
        {t(`pages.create_recovery_plan.registrations_start_date.lead.${domain}`)}
      </p>

      <FormikWrapper
        initialValues={{
          startDate: currentStartDate,
        }}
        onSubmit={(values: Form, formikHelpers: FormikHelpers<Form>) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          onSubmit(values);
          formikHelpers.setSubmitting(false);
        }}
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <FormDatePicker
          fieldName="startDate"
          title={t('pages.account.settings.fields.registrations_start_date.label')}
          isClearable={false}
          isSearchable={false}
          description={t('pages.account.settings.fields.registrations_start_date.description')}
          dateFormat="dd/MM/yyyy"
          popperPlacement="bottom-end"
          maxDate={currentStartDate}
        />

        <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
          <Button htmlType="submit" className={buildClass('submit')} buttonState={submitting ? 'disabled' : ''}>
            {t('buttons.next')}
          </Button>
        </div>
      </FormikWrapper>
    </>
  );
};

type CurrentUsageValues = Pick<FormValues,
| 'monday'
| 'tuesday'
| 'wednesday'
| 'thursday'
| 'friday'
| 'saturday'
| 'sunday'
>;

interface CurrentUsageFormProps {
  initialValues: CurrentUsageValues
  onSubmit: (values: CurrentUsageValues) => void;
}

const CurrentUsageForm: React.FC<CurrentUsageFormProps> = ({
  initialValues,
  onSubmit,
}) => {
  type Form = typeof initialValues;

  const validationSchema = useValidationSchema();

  const schema = validationSchema.pick([
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]);

  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { actionsRef } = useModalContext();

  const { t } = useTranslation();

  const domain = useCurrentDomain();

  return (
    <>
      <h2 className={buildClass('title')}>
        {t(`pages.create_recovery_plan.current_usage.title.${domain}`)}
      </h2>

      <p className={buildClass('lead')}>
        {t(`pages.create_recovery_plan.current_usage.lead.${domain}`)}
      </p>

      <FormikWrapper
        initialValues={initialValues}
        onSubmit={(values: Form, formikHelpers: FormikHelpers<Form>) => {
          formikHelpers.setSubmitting(false);
          onSubmit(values);
        }}
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <>
          {Object.keys(initialValues).map((dayOfWeek) => (
            <>
              <StepperField
                key={`stepper-day-of-week-${dayOfWeek}`}
                fieldName={dayOfWeek}
                title={t(`dates.${dayOfWeek}`)}
                unitName={t(`pages.create_recovery_plan.units.${domain}`)}
                // eslint-disable-next-line max-len
                stepIncrement={domain === DOMAIN_ZELFHULP_GOKKEN ? Number(ZELFHULP_GOKKEN_USAGE_STEP_INCREMENT) : Number(USAGE_STEP_INCREMENT)}
                max={domain === DOMAIN_ZELFHULP_GOKKEN && Number(ZELFHULP_GOKKEN_MAX_USAGE)}
              />
              <CheckIfCorrectWarning dayOfWeek={dayOfWeek} />
            </>
          ))}

          <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
            <Button htmlType="submit" className={buildClass('submit')}>
              {t('buttons.next')}
            </Button>
          </div>
        </>
      </FormikWrapper>
    </>
  );
};

function CheckIfCorrectWarning({ dayOfWeek }: { dayOfWeek: string }) {
  const formik = useExtendedFormikContext();
  const domain = useCurrentDomain();
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  if (domain !== DOMAIN_ZELFHULP_ALCOHOL) {
    return null;
  }

  if (!formik.values[dayOfWeek]) {
    return null;
  }


  if (parseFloat(formik.values[dayOfWeek] as string) < ZELFHULP_ALCOHOL_USAGE_WARNING_THRESHOLD) {
    return null;
  }

  return (
    <div className={buildClass('warning')}>
      {t('pages.create_recovery_plan.check_if_correct')}
    </div>
  );
}

interface StopOrReduceFormProps {
  initialValues: Pick<FormValues, 'stopOrReduce'>;
  onSubmit: (values: Partial<FormValues>) => void;
}

const StopOrReduceFormInner = () => {
  const formik = useExtendedFormikContext();
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageCreateRecoveryPlan');
  const domain = useCurrentDomain();

  const { actionsRef } = useModalContext();

  return (
    <>
      <SwitchButtons
        title={t('pages.create_recovery_plan.stop_or_reduce.title')}
        hideTitle
        fieldName="stopOrReduce"
        options={{
          stop: t(`pages.create_recovery_plan.stop_or_reduce.stop.${domain}`),
          reduce: t(`pages.create_recovery_plan.stop_or_reduce.reduce.${domain}`),
        }}
        value={formik.values.stopOrReduce}
        error={formik.errors.stopOrReduce}
      />

      <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
        <Button
          htmlType="submit"
          className={buildClass('submit')}
        >
          {t('buttons.next')}
        </Button>
      </div>
    </>
  );
};

const StopOrReduceForm: React.FC<StopOrReduceFormProps> = ({
  initialValues,
  onSubmit,
}) => {
  const validationSchema = useValidationSchema('stopOrReduce');

  const schema = validationSchema.pick(['stopOrReduce']);

  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { t } = useTranslation();

  const domain = useCurrentDomain();

  return (
    <>
      <h2 className={buildClass('title')}>
        {t('pages.create_recovery_plan.stop_or_reduce.title')}
      </h2>

      {[
        ...t(`pages.create_recovery_plan.stop_or_reduce.content.${domain}`, {
          returnObjects: true,
        }),
      ].map((content, idx) => (
        <p
          className={buildClass('content')}
          key={`stop_or_reduce_content-${idx}`}
        >
          {content}
        </p>
      ))}

      <p className={buildClass('registrations-start-date')}>
        {t(`pages.create_recovery_plan.stop_or_reduce.registrations_start_date.${domain}`)}
      </p>

      <FormikWrapper
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <StopOrReduceFormInner />
      </FormikWrapper>
    </>
  );
};

interface ImmediateOrGradualFormProps {
  initialValues: Pick<FormValues, 'immediate_or_gradual'>;
  onSubmit: (values: Partial<FormValues>) => void;
}

const ImmediateOrGradualFormInner = () => {
  const formik = useExtendedFormikContext();

  const { t } = useTranslation('translation', { keyPrefix: `pages.create_recovery_plan.immediate_or_gradual_${formik.values.stopOrReduce || 'stop'}_usage` });

  return (
    <SwitchButtons
      title={t('title')}
      hideTitle
      fieldName="immediate_or_gradual"
      options={{
        immediate: t('immediate'),
        gradual: t('gradual'),
      }}
      value={formik.values.immediate_or_gradual}
      error={formik.errors.immediate_or_gradual}
    />
  );
};

const ImmediateOrGradualForm: React.FC<ImmediateOrGradualFormProps> = ({
  initialValues,
  onSubmit,
}) => {
  type Form = typeof initialValues;

  const validationSchema = useValidationSchema('immediateOrGradual');

  const schema = validationSchema.pick(['immediate_or_gradual']);

  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { t } = useTranslation();
  const domain = useCurrentDomain();
  const { actionsRef } = useModalContext();

  return (
    <>
      <h2 className={buildClass('title')}>
        {t('pages.create_recovery_plan.immediate_or_gradual_stop_usage.title')}
      </h2>

      <p className={buildClass('content')}>
        <Trans i18nKey={`pages.create_recovery_plan.immediate_or_gradual_stop_usage.content.${domain}`}>
          <a href={String(URL_JELLINEK_GOAL_PROS_CONS)} target="_blank" rel="noopener noreferrer" />
        </Trans>
      </p>

      <FormikWrapper
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <ImmediateOrGradualFormInner />

        <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
          <Button
            type="submit"
            className={buildClass('submit')}
          >
            {t('buttons.next')}
          </Button>
        </div>
      </FormikWrapper>
    </>
  );
};

interface SetGoalsFormProps {
  initialValues: Pick<
  FormValues,
  | 'goal_monday'
  | 'goal_tuesday'
  | 'goal_wednesday'
  | 'goal_thursday'
  | 'goal_friday'
  | 'goal_saturday'
  | 'goal_sunday'
  | 'immediate_or_gradual'
  >;
  onSubmit: (values: Partial<FormValues>) => void;
  ctx: FormValues;
  isMaxAlcoholUsage: boolean;
}

const SetGoalsForm: React.FC<SetGoalsFormProps> = ({
  initialValues,
  onSubmit,
  ctx,
  isMaxAlcoholUsage,
}) => {
  type Form = typeof initialValues;

  const domain = useCurrentDomain();

  const validationSchema = useValidationSchema(domain !== DOMAIN_ZELFHULP_ALCOHOL ? 'immediateOrGradual' : 'none');

  const schema = validationSchema.pick([
    'goal_monday',
    'goal_tuesday',
    'goal_wednesday',
    'goal_thursday',
    'goal_friday',
    'goal_saturday',
    'goal_sunday',
    'immediate_or_gradual',
  ]);

  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { t } = useTranslation();
  const { actionsRef } = useModalContext();

  const goalsDays = Object.keys(initialValues).filter((key) => key.includes('goal_'));

  return (
    <>
      <h2 className={buildClass('title')}>
        {t(`pages.create_recovery_plan.set_goals.title.${domain}`)}
      </h2>

      <p className={buildClass('lead')}>
        {t(`pages.create_recovery_plan.set_goals.content.${domain}`)}
      </p>

      <FormikWrapper
        initialValues={initialValues}
        onSubmit={(values: Form) => {
          if (domain === DOMAIN_ZELFHULP_ALCOHOL && isMaxAlcoholUsage) {
            onSubmit({
              ...values,
              immediate_or_gradual: 'gradual',
            });
          } else {
            onSubmit(values);
          }
        }}
        validationSchema={schema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <>
          {goalsDays.map((dayOfWeek) => (
            <StepperField
              fieldName={dayOfWeek}
              title={t(`dates.${dayOfWeek.slice(5)}`)}
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              hint={t(`pages.create_recovery_plan.set_goals.hint.${domain}`, { usage: ctx[dayOfWeek.slice(5)] })}
              unitName={t(`pages.create_recovery_plan.units.${domain}`)}
              // eslint-disable-next-line max-len
              stepIncrement={domain === DOMAIN_ZELFHULP_GOKKEN ? Number(ZELFHULP_GOKKEN_USAGE_STEP_INCREMENT) : Number(USAGE_STEP_INCREMENT)}
              max={domain === DOMAIN_ZELFHULP_GOKKEN && Number(ZELFHULP_GOKKEN_MAX_USAGE)}
            />
          ))}

          {!isMaxAlcoholUsage && (
            <>
              <h2 className={buildClass('title')}>
                {t('pages.create_recovery_plan.immediate_or_gradual_reduce_usage.title')}
              </h2>

              <p className={buildClass('content')}>
                <Trans i18nKey={`pages.create_recovery_plan.immediate_or_gradual_reduce_usage.content.${domain}`}>
                  <a href={String(URL_JELLINEK_GOAL_PROS_CONS)} target="_blank" rel="noopener noreferrer" />
                </Trans>
              </p>

              <ImmediateOrGradualFormInner />
            </>
          )}
        </>

        <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
          <Button
            htmlType="submit"
            className={buildClass('submit')}
          >
            {t('buttons.next')}
          </Button>
        </div>

      </FormikWrapper>
    </>
  );
};

interface BuddyFormProps {
  onSubmit: () => void;
}

const BuddyForm: React.FC<BuddyFormProps> = ({ onSubmit }) => {
  const dispatch = useTypedDispatch();
  const toast = useToast();
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { actionsRef } = useModalContext();

  const translationBase = 'pages.create_recovery_plan.buddy';

  function handleSubmit({ name, email }: BuddiesFormValues) {
    async function addBuddy() {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      await dispatch(userAddBuddy(name, email));
    }

    addBuddy()
      .then(() => {
        onSubmit();
      })
      .catch((error) => {
        toast.show(t(`${translationBase}.add.error_message`, { name }), 'error');
        console.error(error);
      });
  }

  return (
    <>
      <h2 className={buildClass('title')}>
        {t(`${translationBase}.title`)}
      </h2>

      <p className={buildClass('lead')}>
        {t(`${translationBase}.lead`)}
      </p>

      <BuddiesForm>
        <BuddiesForm.FormikWrapper
          translationBase={translationBase}
          onSubmit={(values, { setSubmitting }) => {
            handleSubmit(values);
            setSubmitting(false);
          }}
        >
          <BuddiesForm.Fields translationBase={translationBase} />

          <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
            <Button
              inverted
              onClick={() => {
                onSubmit();
              }}
            >
              {t('buttons.skip')}
            </Button>

            <BuddiesForm.Submit translationBase={translationBase} />
          </div>
        </BuddiesForm.FormikWrapper>
      </BuddiesForm>
    </>
  );
};

interface DoneProps {
  isLoading?: boolean;
  onSubmit: () => void;
}

const Done: React.FC<DoneProps> = (props) => {
  const {
    isLoading = false,
    onSubmit,
  } = props;
  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { t } = useTranslation();
  const domain = useCurrentDomain();

  const { actionsRef } = useModalContext();

  return (
    <>
      <h2 className={buildClass('title')}>
        {t('pages.create_recovery_plan.done.title')}
      </h2>

      {[
        ...t(`pages.create_recovery_plan.done.content.${domain}`, {
          returnObjects: true,
        }),
      ].map((content, idx) => (
        <p className={buildClass('content')} key={`done-content-${idx}`}>
          {content}
        </p>
      ))}

      <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
        <Button
          buttonState={isLoading && 'disabled'}
          onClick={() => onSubmit()}
        >
          {t('pages.create_recovery_plan.done.button')}
        </Button>
      </div>
    </>
  );
};

interface AlcoholGradualReductionFormProps {
  onSubmit: (values: Partial<FormValues>) => void;
}

const AlcoholGradualReductionForm: React.FC<
AlcoholGradualReductionFormProps
> = ({ onSubmit }) => {
  const { buildClass } = useClasses('PageCreateRecoveryPlan');

  const { actionsRef } = useModalContext();

  const { t } = useTranslation();

  return (
    <>
      <h2 className={buildClass('title')}>
        {t('pages.create_recovery_plan.alcohol_gradual_reduction.title')}
      </h2>

      <p className={buildClass('content')}>
        {t('pages.create_recovery_plan.alcohol_gradual_reduction.content')}
      </p>

      <div className="PageCreateRecoveryPlan__actions" ref={actionsRef}>
        <Button
          htmlType="button"
          className={buildClass('submit')}
          onClick={() => onSubmit({
            immediate_or_gradual: 'gradual',
            goal_monday: '0',
            goal_tuesday: '0',
            goal_wednesday: '0',
            goal_thursday: '0',
            goal_friday: '0',
            goal_saturday: '0',
            goal_sunday: '0',
          })}
        >
          {t('buttons.next')}
        </Button>
      </div>
    </>
  );
};

interface PageRecoveryPlanProps {
  onSuccessfulSubmit: () => void;
}

const PageCreateRecoveryPlan: React.FC<PageRecoveryPlanProps> = ({
  onSuccessfulSubmit,
}) => {
  const { buildClass, joinClasses } = useClasses('PageCreateRecoveryPlan');

  const { t } = useTranslation();

  const domain = useCurrentDomain();

  const initialValues: FormValues = {
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: '',
    sunday: '',
    stopOrReduce: domain === DOMAIN_ZELFHULP_TABAK ? 'stop' : '',
    immediate_or_gradual: '',
    goal_monday: '',
    goal_tuesday: '',
    goal_wednesday: '',
    goal_thursday: '',
    goal_friday: '',
    goal_saturday: '',
    goal_sunday: '',
  };

  const [currentStep, setCurrentStep] = React.useState<Step>(
    ENABLE_REGISTRATIONS_START_DATE_STEP ? Step.StopDate : Step.CurrentUsage,
  );
  const [values, setValues] = React.useState<FormValues>(initialValues);
  const [isLoading, setLoading] = React.useState(false);
  const isMaxAlcoholUsage = isAlcoholUsageLimitReached(values);

  const { modalRef } = useModalContext();

  const focusToBody = useProgrammaticFocus(document.body);

  React.useEffect(() => {
    modalRef?.current?.scrollTo(0, 0);

    focusToBody();
  }, [currentStep, focusToBody, modalRef]);

  const userHasBuddies = useSelector<UserState, boolean>((state) => {
    const uid = state.getIn(['login', 'uid'], null);
    return state.getIn(['user', uid, 'field_buddies'], Immutable.List()).size > 0;
  });

  const [steps, totalSteps] = React.useMemo(() => {
    const currentSteps = Object.values(Step).reduce((acc, step) => {
      if (step === Step.StopDate && !ENABLE_REGISTRATIONS_START_DATE_STEP) {
        return acc;
      }

      if (step === Step.Buddy && userHasBuddies) {
        return acc;
      }

      acc.push(step);
      return acc;
    }, [] as Step[]);

    return [currentSteps, currentSteps.length];
  }, [userHasBuddies]);

  const dispatch = useTypedDispatch();

  const nextStep = (newValues?: Partial<FormValues>) => {
    setValues((oldValues) => ({
      ...oldValues,
      ...newValues,
    }));
    setCurrentStep((oldStep) => steps[steps.indexOf(oldStep) + 1]);
  };

  const skipToStep = (newStep: Step) => {
    setCurrentStep(newStep);
  };

  const onSubmit = async () => {
    setLoading(true);

    await dispatch(webformSubmit('goal', values)).then(() => {
      setLoading(false);
      onSuccessfulSubmit();
    });
  };

  const popup = usePopup('alcohol-warning');

  return (
    <div className={joinClasses(buildClass(), 'col-lg-8', 'offset-lg-2')}>
      {popup.isOpen && (
        <Popup
          {...popup.popupProps}
          onClose={() => {
            popup.close();
            nextStep();
          }}
          title={t('pages.create_recovery_plan.alcohol_warning.title')}
          cta={<Button href={URL_JELLINEK}>{t('pages.create_recovery_plan.alcohol_warning.to_jellinek')}</Button>}
          closeButtonText={t('pages.create_recovery_plan.alcohol_warning.continue')}
        >
          {[...t('pages.create_recovery_plan.alcohol_warning.content', { returnObjects: true })].map((content, idx) => (
            <p className="content" key={`alcohol-warning-${idx}`}>
              {content}
            </p>
          ))}
        </Popup>
      )}
      <WebformStepCounter
        pages={Array.from({ length: totalSteps }, (x, i) => i + 1)}
        currentPage={steps.indexOf(currentStep) + 1}
      />

      {currentStep === Step.StopDate && (
        <StopDateForm nextStep={nextStep} />
      )}

      {currentStep === Step.CurrentUsage && (
        <CurrentUsageForm
          initialValues={pick(
            values,
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday',
          )}
          onSubmit={(submittedValues) => {
            // Update new values.
            setValues((oldValues) => ({
              ...oldValues,
              ...submittedValues,
            }));

            const showWarning = isAlcoholUsageLimitReached(submittedValues);

            if (showWarning) {
              popup.open();
              return;
            }

            if (domain === DOMAIN_ZELFHULP_TABAK) {
              setValues((oldValues) => ({
                ...oldValues,
                stopOrReduce: 'stop',
              }));
              skipToStep(Step.ImmediateOrGradual);
              return;
            }

            nextStep();
          }}
        />
      )}

      {currentStep === Step.StopOrReduce && (
        <StopOrReduceForm
          initialValues={pick(values, 'stopOrReduce')}
          onSubmit={(submittedValues) => {
            nextStep(submittedValues);
          }}
        />
      )}

      {currentStep === Step.ImmediateOrGradual &&
        (domain !== DOMAIN_ZELFHULP_ALCOHOL || !isMaxAlcoholUsage) &&
        values.stopOrReduce === 'stop' && (
          <ImmediateOrGradualForm
            initialValues={pick(values, 'immediate_or_gradual')}
            onSubmit={nextStep}
          />
      )}

      {currentStep === Step.ImmediateOrGradual &&
        domain === DOMAIN_ZELFHULP_ALCOHOL &&
        isMaxAlcoholUsage &&
        values.stopOrReduce === 'stop' && (
          <AlcoholGradualReductionForm onSubmit={nextStep} />
      )}

      {currentStep === Step.ImmediateOrGradual && values.stopOrReduce === 'reduce' && (
        <SetGoalsForm
          initialValues={pick(
            values,
            'goal_monday',
            'goal_tuesday',
            'goal_wednesday',
            'goal_thursday',
            'goal_friday',
            'goal_saturday',
            'goal_sunday',
            'stopOrReduce',
            'immediate_or_gradual',
          )}
          onSubmit={nextStep}
          ctx={values}
          isMaxAlcoholUsage={isMaxAlcoholUsage}
        />
      )}

      {currentStep === Step.Buddy && (
        <BuddyForm onSubmit={nextStep} />
      )}

      {currentStep === Step.Done && (
        <Done
          isLoading={isLoading}
          onSubmit={() => {
            onSubmit().catch((error) => console.error(error));
          }}
        />
      )}
    </div>
  );
};

export default PageCreateRecoveryPlan;
